function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import SemResultsProvider from './providers/SemResultsProvider';
import { Page as SemResultsPage } from './pages/sem_results';
import { Page as SemTripSummaryPage } from './pages/sem_trip_summary';
import { Page as SemFiltersPage } from './pages/sem_filters';
import { useItineraryFromUrl } from '@edreamsodigeo/frontend-checkout';
import { ErrorNamespaceProvider, BlockingErrorBoundary } from '@edreamsodigeo/frontend-core';
const SemResultsWrapper = ({
  semResultsProviderProps,
  children
}) => {
  const itineraryFromUrl = useItineraryFromUrl();
  return /*#__PURE__*/React.createElement(SemResultsProvider, _extends({
    itineraryFromUrl: itineraryFromUrl
  }, semResultsProviderProps), children);
};
SemResultsWrapper.propTypes = {
  semResultsProviderProps: PropTypes.object,
  children: PropTypes.node.isRequired
};
export const SemResultsFunnel = semResultsProviderProps => {
  return /*#__PURE__*/React.createElement(ErrorNamespaceProvider, {
    namespace: "shell_funnel_sem_results"
  }, /*#__PURE__*/React.createElement(BlockingErrorBoundary, {
    name: "funnel_sem_results"
  }, /*#__PURE__*/React.createElement(SemResultsWrapper, {
    semResultsProviderProps: semResultsProviderProps
  }, /*#__PURE__*/React.createElement(SemResultsPage, null), /*#__PURE__*/React.createElement(SemFiltersPage, null), /*#__PURE__*/React.createElement(SemTripSummaryPage, null))));
};